(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-course"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-cre-participant]');
  if (!root) return;

  var KEYS = ['first_name', 'last_name', 'email'];
  var fields = root.querySelector('[data-cre-participant-fields]');
  var globalError = root.querySelector('[data-cre-participant-error-global]');
  var choiceInputs = root.querySelectorAll('[data-cre-participant-choice]');
  var choiceLabels = root.querySelectorAll('[data-cre-participant-choice-label]');

  var visibleInputs = {};
  KEYS.forEach(function (k) {
    visibleInputs[k] = root.querySelector('[data-cre-participant-input="' + k + '"]');
  });

  function getChoice() {
    for (var i = 0; i < choiceInputs.length; i++) {
      if (choiceInputs[i].checked) return choiceInputs[i].value;
    }
    return null;
  }

  function hiddenInputsFor(key) {
    return document.querySelectorAll(
      '[data-cre-participant-hidden="' + key + '"], [data-cre-participant-hidden-mirror="' + key + '"]'
    );
  }

  function syncHidden() {
    var choice = getChoice();
    KEYS.forEach(function (key) {
      var value = choice === 'other' ? (visibleInputs[key].value || '').trim() : '';
      hiddenInputsFor(key).forEach(function (h) { h.value = value; });
    });
  }

  function setFieldsRequired(required) {
    KEYS.forEach(function (key) {
      var input = visibleInputs[key];
      if (required) input.setAttribute('required', '');
      else input.removeAttribute('required');
    });
  }

  function clearFieldErrors() {
    root.querySelectorAll('.cre-participant__error:not(.cre-participant__error--global)').forEach(function (el) { el.remove(); });
    root.querySelectorAll('.cre-participant__field--invalid').forEach(function (el) {
      el.classList.remove('cre-participant__field--invalid');
    });
  }

  function clearGlobalError() {
    if (globalError) globalError.setAttribute('hidden', '');
  }

  function showFieldError(input, message) {
    var wrapper = input.closest('.cre-participant__field');
    if (!wrapper) return;
    wrapper.classList.add('cre-participant__field--invalid');
    var error = document.createElement('p');
    error.className = 'cre-participant__error';
    error.textContent = message;
    wrapper.appendChild(error);
  }

  function showGlobalError() {
    if (globalError) globalError.removeAttribute('hidden');
  }

  function updateChoiceVisuals() {
    var choice = getChoice();
    choiceLabels.forEach(function (label) {
      var key = label.getAttribute('data-cre-participant-choice-label');
      if (key === choice) label.classList.add('cre-participant__choice--selected');
      else label.classList.remove('cre-participant__choice--selected');
    });
  }

  function onChoiceChange() {
    clearGlobalError();
    updateChoiceVisuals();
    var choice = getChoice();
    if (choice === 'other') {
      fields.removeAttribute('hidden');
      setFieldsRequired(true);
    } else {
      fields.setAttribute('hidden', '');
      setFieldsRequired(false);
      KEYS.forEach(function (key) { visibleInputs[key].value = ''; });
      clearFieldErrors();
    }
    syncHidden();
  }

  choiceInputs.forEach(function (input) {
    input.addEventListener('change', onChoiceChange);
  });
  KEYS.forEach(function (key) {
    visibleInputs[key].addEventListener('input', syncHidden);
  });

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var forms = document.querySelectorAll('form#cre-product-form, form#cre-product-form-bottom');

  forms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var choice = getChoice();

      // Mandatory choice — neither radio selected
      if (!choice) {
        e.preventDefault();
        showGlobalError();
        if (root.scrollIntoView) root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (choice === 'self') {
        // Choice made, no fields needed. Ensure hidden inputs are empty.
        syncHidden();
        return;
      }

      // choice === 'other' — validate the 3 fields
      clearFieldErrors();
      var firstInvalid = null;

      KEYS.forEach(function (key) {
        var input = visibleInputs[key];
        var value = (input.value || '').trim();
        if (!value) {
          showFieldError(input, 'This field is required.');
          firstInvalid = firstInvalid || input;
        } else if (key === 'email' && !EMAIL_RE.test(value)) {
          showFieldError(input, 'Please enter a valid email address.');
          firstInvalid = firstInvalid || input;
        }
      });

      if (firstInvalid) {
        e.preventDefault();
        fields.removeAttribute('hidden');
        firstInvalid.focus();
        if (firstInvalid.scrollIntoView) firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        syncHidden();
      }
    });
  });
})();

/* -----------------------------------------------------------------
 * ILT booking widget: lists Zoho sessions for this product's variant
 * and offers two paths per session — pay now (Shopify cart) or
 * reserve/request a quote (POST to the Vercel bridge).
 * ----------------------------------------------------------------- */
(function () {
  var root = document.querySelector('[data-cre-sessions]');
  if (!root) return;

  var bridge = (root.getAttribute('data-bridge') || '').replace(/\/+$/, '');
  var variant = root.getAttribute('data-variant');
  var listEl = root.querySelector('[data-cre-sessions-list]');
  var i18nEl = root.querySelector('[data-cre-i18n]');
  var T = {};
  try { T = JSON.parse(i18nEl.textContent); } catch (e) { T = {}; }
  var locale = T.locale || document.documentElement.lang || 'en';

  var reserve = root.querySelector('[data-cre-reserve]');
  var reserveForm = root.querySelector('[data-cre-reserve-form]');
  var reserveSessionLabel = root.querySelector('[data-cre-reserve-session]');
  var reserveSessionId = root.querySelector('[data-cre-reserve-session-id]');
  var reserveError = root.querySelector('[data-cre-reserve-error]');
  var reserveSuccess = root.querySelector('[data-cre-reserve-success]');
  var reserveCancel = root.querySelector('[data-cre-reserve-cancel]');
  var reserveSubmit = root.querySelector('[data-cre-reserve-submit]');

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function msg(text) {
    listEl.innerHTML = '';
    var p = document.createElement('p');
    p.className = 'cre-sessions__msg';
    p.textContent = text || '';
    listEl.appendChild(p);
  }

  function fmtDate(iso) {
    if (!iso) return '';
    try {
      return new Intl.DateTimeFormat(locale, {
        weekday: 'short', day: 'numeric', month: 'long', year: 'numeric'
      }).format(new Date(iso));
    } catch (e) { return String(iso).slice(0, 10); }
  }

  function seatsLabel(n) {
    if (n === null || n === undefined || n <= 0) return '';
    return n === 1 ? T.seatsOne : (T.seatsOther || '{count}').replace('{count}', n);
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function render(sessions) {
    listEl.innerHTML = '';
    if (!sessions.length) { msg(T.none); return; }
    sessions.forEach(function (s) {
      var card = el('div', 'cre-session');

      var info = el('div', 'cre-session__info');
      info.appendChild(el('p', 'cre-session__date', fmtDate(s.from)));
      var bits = [];
      if (s.location) bits.push(s.location);
      if (s.language) bits.push(s.language);
      info.appendChild(el('p', 'cre-session__meta', bits.join(' · ')));
      var seats = seatsLabel(s.remainingSeats);
      if (seats) info.appendChild(el('span', 'cre-session__seats', seats));
      card.appendChild(info);

      var actions = el('div', 'cre-session__actions');
      var payBtn = el('button', 'cre-btn cre-btn--primary cre-session__btn', T.pay);
      payBtn.type = 'button';
      payBtn.addEventListener('click', function () { pay(s, payBtn); });
      actions.appendChild(payBtn);
      var resBtn = el('button', 'cre-btn cre-btn--ghost cre-session__btn', T.reserve);
      resBtn.type = 'button';
      resBtn.addEventListener('click', function () { openReserve(s); });
      actions.appendChild(resBtn);
      card.appendChild(actions);

      listEl.appendChild(card);
    });
  }

  function pay(s, btn) {
    btn.disabled = true;
    var props = { 'Session': s.name || s.sessionId || '' };
    if (s.sessionId) props['Session ID'] = s.sessionId;
    if (s.from) props['Date'] = fmtDate(s.from);
    if (s.location) props['Location'] = s.location;
    if (s.language) props['Language'] = s.language;
    props['_zoho_session_id'] = s.id; // hidden (underscore) — for order automation
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variant, quantity: 1, properties: props })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = '/checkout';
    }).catch(function () {
      btn.disabled = false;
      showErr(T.formError);
    });
  }

  function openReserve(s) {
    reserveSessionId.value = s.id;
    reserveSessionLabel.textContent = fmtDate(s.from) + (s.location ? ' · ' + s.location : '');
    reserveSuccess.setAttribute('hidden', '');
    reserveError.setAttribute('hidden', '');
    reserveForm.style.display = '';
    reserve.removeAttribute('hidden');
    reserve.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function val(name) {
    var f = reserveForm.querySelector('[data-f="' + name + '"]');
    return f ? (f.value || '').trim() : '';
  }

  function showErr(text) {
    reserveError.textContent = text || '';
    reserveError.removeAttribute('hidden');
  }

  if (reserveCancel) {
    reserveCancel.addEventListener('click', function () { reserve.setAttribute('hidden', ''); });
  }

  reserveForm.addEventListener('submit', function (e) {
    e.preventDefault();
    reserveError.setAttribute('hidden', '');
    var firstName = val('firstName'), lastName = val('lastName'), email = val('email');
    if (!firstName || !lastName || !email) { showErr(T.required); return; }
    if (!EMAIL_RE.test(email)) { showErr(T.invalidEmail); return; }

    var payload = {
      sessionId: reserveSessionId.value,
      firstName: firstName, lastName: lastName, email: email,
      phone: val('phone'), company: val('company'), jobTitle: val('jobTitle'),
      participants: parseInt(val('participants'), 10) || 1,
      notes: val('notes'),
      website: (reserveForm.querySelector('[name="website"]') || {}).value || ''
    };
    reserveSubmit.disabled = true;
    reserveSubmit.textContent = T.sending;
    fetch(bridge + '/api/ilt-reserve', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function () {
        reserveForm.style.display = 'none';
        reserveSuccess.removeAttribute('hidden');
      })
      .catch(function () { showErr(T.formError); })
      .then(function () {
        reserveSubmit.disabled = false;
        reserveSubmit.textContent = T.submit;
      });
  });

  document.querySelectorAll('[data-cre-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector('#cre-sessions');
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  if (!bridge || !variant) { msg(T.error); return; }
  fetch(bridge + '/api/ilt-sessions?variant=' + encodeURIComponent(variant))
    .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
    .then(function (data) { render((data && data.sessions) || []); })
    .catch(function () { msg(T.error); });
})();

  } catch(e) { console.error(e); }
})();
})();
